import styled from "@emotion/styled";
import MetabotLogo from "metabase/core/components/MetabotLogo";

export const MetabotIcon = styled(MetabotLogo)`
  display: block;
  width: 4.5rem;
`;
